import { render, staticRenderFns } from "./OpportunityStatusChip.vue?vue&type=template&id=43f08001"
import script from "./OpportunityStatusChip.vue?vue&type=script&lang=js"
export * from "./OpportunityStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports